import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const acutetoxs =
{
    namespaced: true,
    state: {
        acutetoxs: [],
        acutetox: {}
    },
    mutations: {
        SET_ACUTETOXS(state, data) {
            state.acutetoxs = data
        },
        SET_ACUTETOX(state, data) {
            state.acutetox = data
        }
    },
    actions: {
        getAll({ commit }) {
            return axios
                .get(baseUrl + 'GHSAcutetox', { withCredentials: true })
                .then(res => {
                    console.log(res.data);
                    commit('SET_ACUTETOXS', res.data)

                })
                .catch(error => console.log(error))
        },

        deleteAcuteTox({ commit }, id) {
            return axios
                .get(baseUrl + 'DeleteVendor?vendorId=' + id, { withCredentials: true })
                .catch(error => console.log(error))
        },

        updateAcuteTox({ commit }, {id, data}) {
            return axios
                .post(baseUrl + 'GHSAcutetox/updateAcuteTox/' + id, data, { withCredentials: true })
                .then(res => {

                    console.log(res)
                })
        },

        //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
        getAcuteTox({ commit }, id) {
            return axios
                .get(baseUrl + 'GetVendor?vendorId=' + id, { withCredentials: true })
                .then(res => {
                    commit('SET_VENDOR', res.data)
                })
                .catch(error => console.log(error))
        },
        addNewAcuteTox({ commit }, data) {
            return axios
                .post(baseUrl + 'GHSAcutetox/addAcuteTox', data, { withCredentials: true })
                .then(res => {
                    console.log("acutetox Added:", res.data)
                })
                .catch(error => console.log(error))
        }
    },
    getters: {}
}

export default acutetoxs